import { render, staticRenderFns } from "./adagent.vue?vue&type=template&id=9f964010&scoped=true&"
import script from "./adagent.vue?vue&type=script&lang=js&"
export * from "./adagent.vue?vue&type=script&lang=js&"
import style0 from "./adagent.vue?vue&type=style&index=0&id=9f964010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f964010",
  null
  
)

export default component.exports